module.exports = __webpack_public_path__ + "static/img/no_data.6fe6dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/no_data.png
// module id = aS29
// module chunks = 1